<app-loader *ngIf="isLoading"></app-loader>
<form *ngIf="!isLoading" method="post" [formGroup]="form">
  <div class="row mt-3">
    <div class="col-6">
      <div class="form-group">
        <label>Azonosító<span class="required-label" *ngIf="identifier.errors?.['required']">*</span></label>
        <input id="identifier" type="text" class="form-control datetimepicker" formControlName="identifier" />
      </div>

      <div *ngIf="identifier.invalid && (identifier.dirty || identifier.touched)" class="alert alert-danger">
        <div *ngIf="identifier.errors?.['required']">Az azonosító kötelező.</div>
        <div *ngIf="identifier.errors?.['serverError']">{{identifier.errors?.['serverError']}}</div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-6">
      <div class="form-group">
        <label>Nyitás időpontja<span class="required-label" *ngIf="openedAtUtc.errors?.['required']">*</span></label>
        <input id="openedAtUtc" type="text" class="form-control" formControlName="openedAtUtc" appDateTimePicker />
      </div>
      <div *ngIf="form.errors?.['startedOpenedInvalidDate'] && (form.touched || form.dirty)" class="alert alert-danger">
        Nyitás időpontjának korábbinak kell lennie a Vizsga kezdetétől.
      </div>
      <div *ngIf="form.errors?.['openedClosedNotOnSameDay'] && (form.touched || form.dirty)" class="alert alert-danger">
        Nyitás időpontjának és a Zárás időpontjának egy napra kell esnie.
      </div>
      <div *ngIf="form.errors?.['openedClosedInvalidDate'] && (form.touched || form.dirty)" class="alert alert-danger">
        Nyitás időpontjának korábbinak kell lennie a Zárás időpontjától.
      </div>
      <div *ngIf="openedAtUtc.invalid && (openedAtUtc.dirty || openedAtUtc.touched)" class="alert alert-danger">
        <div *ngIf="openedAtUtc.errors?.['required']">A nyitás időpontja kötelező.</div>
        <div *ngIf="openedAtUtc.errors?.['serverError']">{{openedAtUtc.errors?.['serverError']}}</div>
      </div>

      <div class="form-group">
        <label>Vizsga kezdete<span class="required-label" *ngIf="examStartedAtUtc.errors?.['required']">*</span></label>
        <input
          id="examStartedAtUtc"
          type="text"
          class="form-control"
          formControlName="examStartedAtUtc"
          appDateTimePicker
        />
        <label *ngIf="realExamStartedAtUtc" class="realValue">Tényleges kezdete: {{realExamStartedAtUtc.toString() | date:'y. MMMM d. HH:mm':undefined:'hu-HU'}}</label>
      </div>
      <div *ngIf="form.errors?.['startedOpenedInvalidDate'] && (form.touched || form.dirty)" class="alert alert-danger">
        Nyitás időpontjának korábbinak kell lennie a Vizsga kezdetétől.
      </div>
      <div *ngIf="form.errors?.['examStartEndNotOnSameDay'] && (form.touched || form.dirty)" class="alert alert-danger">
        Vizsga kezdetének és végének egy napra kell esnie.
      </div>
      <div *ngIf="form.errors?.['examStartEndInvalidDate'] && (form.touched || form.dirty)" class="alert alert-danger">
        Vizsga kezdetének korábbinak kell lennie a Vizsga végétől.
      </div>
      <div
        *ngIf="examStartedAtUtc.invalid && (examStartedAtUtc.dirty || examStartedAtUtc.touched)"
        class="alert alert-danger"
      >
        <div *ngIf="examStartedAtUtc.errors?.['required']">Az vizsga kezdete kötelező.</div>
        <div *ngIf="examStartedAtUtc.errors?.['serverError']">{{examStartedAtUtc.errors?.['serverError']}}</div>
      </div>

      <div class="form-group">
        <label>Helyszín<span class="required-label" *ngIf="examAddressId.errors?.['required']">*</span></label>
        <ng-select
          placeholder="Kérem válasszon vizsgahelyszínt!"
          notFoundText="Nincs találat!"
          formControlName="examAddressId"
        >
          <ng-option *ngFor="let option of examAddressesSelectList.items" [value]="option.value">
            {{ option.text }}
          </ng-option>
        </ng-select>
      </div>

      <div *ngIf="examAddressId.invalid && (examAddressId.dirty || examAddressId.touched)" class="alert alert-danger">
        <div *ngIf="examAddressId.errors?.['required']">A vizsga helyszín kötelező.</div>
        <div *ngIf="examAddressId.errors?.['serverError']">{{examAddressId.errors?.['serverError']}}</div>
      </div>

      <div class="form-check">
        <input id="isSkipAllow" type="checkbox" class="form-check-input"
               [checked]="isSkipAllow.value" formControlName="isSkipAllow" />
        <label for="isSkipAllow">Tárgyak passzolásának engedélyezése</label>
      </div>
      <div class="form-check">
        <input id="registerDocuments" type="checkbox" class="form-check-input"
               [checked]="registerDocuments.value" formControlName="registerDocuments" />
        <label for="registerDocuments">Okmányazonosítás bekapcsolása</label>
      </div>
    </div>
    <div class="col-6">
      <div class="form-group">
        <label>Zárás időpontja</label>
        <input id="closedAtUtc" type="text" class="form-control" formControlName="closedAtUtc" appDateTimePicker />
        <div *ngIf="form.errors?.['endedClosedInvalidDate'] && (form.touched || form.dirty)" class="alert alert-danger">
          Vizsga végének korábbinak kell lennie a Zárás időpontjától.
        </div>
        <div *ngIf="form.errors?.['openedClosedNotOnSameDay'] && (form.touched || form.dirty)" class="alert alert-danger">
          Nyitás időpontjának és a Zárás időpontjának egy napra kell esnie.
        </div>
        <div *ngIf="form.errors?.['openedClosedInvalidDate'] && (form.touched || form.dirty)" class="alert alert-danger">
          Nyitás időpontjának korábbinak kell lennie a Zárás időpontjától.
        </div>
        <div *ngIf="closedAtUtc.invalid && (closedAtUtc.dirty || closedAtUtc.touched)" class="alert alert-danger">
          <div *ngIf="closedAtUtc.errors?.['serverError']">{{examEndedAtUtc.errors?.['serverError']}}</div>
        </div>
      </div>
      <div class="form-group">
        <label>Vizsga vége<span class="required-label" *ngIf="examEndedAtUtc.errors?.['required']">*</span></label>
        <input
          id="examEndedAtUtc"
          type="text"
          class="form-control"
          formControlName="examEndedAtUtc"
          appDateTimePicker
        />
        <label *ngIf="realExamEndedAtUtc" class="realValue">Tényleges vége: {{realExamEndedAtUtc.toString() | date:'y. MMMM d. HH:mm':undefined:'hu-HU'}}</label>
      </div>
      <div *ngIf="form.errors?.['endedClosedInvalidDate'] && (form.touched || form.dirty)" class="alert alert-danger">
        Vizsga végének korábbinak kell lennie a Zárás időpontjától.
      </div>
      <div *ngIf="form.errors?.['examStartEndNotOnSameDay'] && (form.touched || form.dirty)" class="alert alert-danger">
        Vizsga kezdetének és végének egy napra kell esnie.
      </div>
      <div *ngIf="form.errors?.['examStartEndInvalidDate'] && (form.touched || form.dirty)" class="alert alert-danger">
        Vizsga kezdetének korábbinak kell lennie a Vizsga végétől.
      </div>
      <div
        *ngIf="examEndedAtUtc.invalid && (examEndedAtUtc.dirty || examEndedAtUtc.touched)"
        class="alert alert-danger"
      >
        <div *ngIf="examEndedAtUtc.errors?.['required']">A vizsga vége kötelező.</div>
        <div *ngIf="examEndedAtUtc.errors?.['serverError']">{{examEndedAtUtc.errors?.['serverError']}}</div>
      </div>

      <div class="form-group">
        <label title="A vizsgázó számára elért eredmény kerekítés nélkül a megadott tizedes jegy pontossággal kerül kijelzésre.">
          Eredmény pontossága
          <span class="required-label" *ngIf="percentagePrecision.errors?.['required']">*</span></label>
        <input
          id="percentagePrecision"
          type="number"
          class="form-control"
          formControlName="percentagePrecision"
          min="0"
          max="3"
          pattern="[0-9]*"
        />
      </div>
      <div
        *ngIf="percentagePrecision.invalid && (percentagePrecision.dirty || percentagePrecision.touched)"
        class="alert alert-danger"
      >
        <div *ngIf="percentagePrecision.errors?.['required']">Az eredmény kijelzés pontosságának megadása kötelező.</div>
        <div *ngIf="percentagePrecision.errors?.['min']">Az eredmény kijelzés pontosságának csak pozitív egész lehet.</div>
        <div *ngIf="percentagePrecision.errors?.['max']">Az eredmény kijelzés pontosságának maximális pontossága 3 tizedes jegy.</div>
        <div *ngIf="percentagePrecision.errors?.['pattern']">A beírt érték csak egész szám lehet.</div>
        <div *ngIf="percentagePrecision.errors?.['serverError']">{{percentagePrecision.errors?.['serverError']}}</div>
      </div>

      <div class="form-check">
        <input id="isExamStartAutomatic" type="checkbox" class="form-check-input"
               [checked]="isExamStartAutomatic.value" formControlName="isExamStartAutomatic" />
        <label for="isExamStartAutomatic">Automatikus vizsga indítás</label>
      </div>
    </div>

  </div>

  <div class="button-group">
    <button
      *ngIf="this.isModifiable"
      (click)="onSubmit()"
      class="btn btn-primary text-white btn-save me-2"
      [disabled]="form.invalid || form.disabled"
    >
      Mentés
    </button>
    <a
       (click)="onGoBack('/exam-reports')"
       class="btn btn-dark">
      Vissza
    </a>
  </div>
</form>
